module.exports = __webpack_public_path__ + "static/media/smart_insights_empty.88421a11.svg";